import React from "react"
import FontSelect from "@kit/design/font-select"
import Select from "@kit/design/select-menu"
import { fontOptions, filterWeights } from "../../shared/fonts"

export function FontSettings({
  label,
  properties,
  fontFamilySetting,
  fontWeightSetting,
  update
}) {
  const filteredWeightOptions = filterWeights(properties[fontFamilySetting])

  function handleFontFamilyChange(e) {
    update({
      [fontFamilySetting]: e.target.value,
      [fontWeightSetting]: 400
    })
  }

  return (
    <div>
      <div className="font-semibold text-gray-700 mb-1">{label}</div>
      <div className="grid grid-cols-2 gap-4">
        <FontSelect
          options={fontOptions}
          value={properties[fontFamilySetting]}
          onChange={handleFontFamilyChange}
        />
        <Select
          options={filteredWeightOptions}
          value={properties[fontWeightSetting]}
          onChange={e => update({ [fontWeightSetting]: e.target.value })}
        />
      </div>
    </div>
  )
}
